<template>
        <widget :title="title" :router="router">
            <selectCom :tabList="tabList" @getTab="getTab" type="subject" v-if="tabList.length > 0"></selectCom>
            <div class="widget_cont" ref="chart_ele"></div>
        </widget>
    </template>
    <script>
        import widget from './zj_warp'
        import selectCom from './select'
        import widgetFilter from './widgetFilter.js'
        export default {
            components: {
                widget,
                selectCom
            },
            props:{
                title:{
                    type:String
                },
                swWidth:{
                    type:Number,
                    default:1
                },
                item:{
                    type:Object
                }
            },
            filters:{
                format:function(val){
                    return '.'+val.split('.')[1]
                }
            },
            data(){
                return {
                    widgetType:1,
                    router:'elective_statistics_list',
                    configList:null,
                    tabList:[],
                    courseId:'',
                    widgetUrl:'/gateway/edumanage/elective/plan/electiveCourse',
                    teacherId:window.appframe.$store.state.userInfo.id
                }
            },
            mounted(){
                let vm = this

                vm.$nextTick(function(){
                    vm.widgetType = _.cloneDeep(vm.swWidth)
                    if(vm.item.configList.length > 0){
                        let configList = vm.item.configList
                        vm.configList = widgetFilter.getFieldMap(configList)
                        let stemp = []
                        for(let i in vm.configList){
                            stemp.push(vm.configList[i])
                        }
                        // vm.widgetUrl = stemp[0].apiUrl
                        vm.querySubject()
                    }
                })
            },
            methods: {
                querySubject(){
                    let vm = this
                    http.get('/gateway/edumanage/widget/courseList?teacherId='+vm.teacherId).then(function(xhr){
                        vm.tabList = xhr.data.data
                        vm.courseId = vm.tabList[0].id
                        vm.query()
                    })
                },
                query(){
                    let vm = this
                    http.get(vm.widgetUrl + '?teacherId='+vm.teacherId+'&courseId='+vm.courseId).then(function(xhr){
                        let objectA = xhr.data.data
                        let barData = [0,0,0]

                        if(objectA){
                            let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                            var newObj = new Object();
                            let barDateTemp = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                            barData = [barDateTemp.classCount ? barDateTemp.classCount : 0,
                                        barDateTemp.capacity ? barDateTemp.capacity : 0,
                                        barDateTemp.stuCount ? barDateTemp.stuCount : 0
                            ]
                        }

                        let myChart = echarts.init(vm.$refs["chart_ele"])
                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'line',
                                    lineStyle: {
                                        opacity: 0
                                    }
                                },
                                formatter: '{b}:{c}'
                            },
                                grid: {
                                    top:'40px',
                                    left: '3%',
                                    right: '4%',
                                    bottom: '3%',
                                    containLabel: true
                                },
                                xAxis: [{
                                    type: 'category',
                                    data: ['开课班数',
                                        '计划学生人数',
                                        '选课人数'
                                    ],
                                    axisLine: {
                                        lineStyle: {
                                        color: '#007bc6',
                                        width:2
                                        }
                                    },
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                        color: '#e9eaea'
                                        }
                                    },
                                    axisTick: {
                                        show: false
                                    },
                                }],
                                yAxis: [{
                                    type: 'value',
                                    name:'（分数）',
                                    nameTextStyle:{
                                        color:'#4183fc'
                                    },
                                    axisTick: {
                                        show: false
                                    },
                                    axisLine: {
                                        lineStyle: {
                                        color: '#007bc6',
                                        width:2
                                        }
                                    },
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                        color: '#e9eaea'
                                        }
                                    },
                                    axisLabel: {
                                        margin: 10,
                                        textStyle: {
                                        fontSize: 12,
                                        color:'#333'
                                        }
                                    },
                                }],
                                series: [{
                                    type: 'bar',
                                    data: barData,
                                    barWidth: 24,
                                    itemStyle: {
                                        normal: {
                                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#42b4f9'
                                            }, {
                                                offset: 1,
                                                color: '#63e7c9'
                                            }]),
                                            opacity: 1,
                                        }
                                    }
                                }]
                            }
                            myChart.setOption(option);
                    })
                },
                getTab(data){
                    let vm = this
                    vm.courseId = data.id
                    vm.query()
                }
            }
        }
    </script>
    <style scoped lang="less">
        .widget_cont{
            height: 260px;
            margin: 10px;
        }
    </style>


// WEBPACK FOOTER //
// src/components/homepage/widget/zj_elective_course_info.vue